import axios from 'axios';
import { env } from '../env';

export const GetConfiguration = (productName, configurationName) => {
    return axios.get(`${env.apiBaseUrl}/api/configurations/${productName}/${configurationName}`);
};

export const GetNamedFeatureFlagValue = () =>{
    return axios.post(`${env.apiBaseUrl}/api/GetNamedFeatureFlagValue`)
};

export const GetNamedFeatureFlag = (serviceName, flagName) =>{
    return axios({
        method: 'post',
        url: `${env.apiBaseUrl}/api/GetNamedFeatureFlag`,
        headers: {},
        data: {
            "serviceName": serviceName,
            "flagName": flagName
        }
    })
};

export const GetAllFeatureFlags = () =>{
    return axios.post(`${env.apiBaseUrl}/api/GetAllFeatureFlags`);
};

export const GetAllConfigurations = () =>{
    return axios.get(`${env.apiBaseUrl}/api/GetAllConfigurations`);
};

export const ModifyFeatureFlag = (featureFlagData, credentials) =>{
    return axios({
        method: 'post',
        url: `${env.apiBaseUrl}/api/ModifyFeatureFlag`,
        headers: {},
        auth: {
            username: credentials.username,
            password: credentials.password
        },
        data: featureFlagData
    })
};

export const DeleteFeatureFlag = (serviceName, flagName, credentials) =>{
    return axios({
        method: 'post',
        url: `${env.apiBaseUrl}/api/DeleteFeatureFlag`,
        headers: {},
        auth: {
            username: credentials.username,
            password: credentials.password
        },
        data: {
            "serviceName": serviceName,
            "flagName": flagName,
            "userName": credentials.username
        }
    })
};

export const AddFeatureFlag = (featureFlagData, credentials) =>{
    return axios({
        method: 'post',
        url: `${env.apiBaseUrl}/api/AddFeatureFlag`,
        headers: {},
        auth: {
            username: credentials.username,
            password: credentials.password
        },
        data: featureFlagData
    })
}; 

export const AddNewConfiguration = (configurationData, credentials) => {
    return axios({
        method: 'post',
        url: `${env.apiBaseUrl}/api/configurations/${configurationData.productName}/${configurationData.configurationName}`,
        headers: {},
        auth: {
            username: credentials.username,
            password: credentials.password
        },
        data: {
            "description": configurationData.description,
            "value": configurationData.value
        }
    })
}

export const UpdateConfiguration = (configurationData, credentials) => {
    return axios({
        method: 'patch',
        url: `${env.apiBaseUrl}/api/configurations/${configurationData.productName}/${configurationData.configurationName}`,
        headers: {},
        auth: {
            username: credentials.username,
            password: credentials.password
        },
        data: {
            "description": configurationData.description,
            "value": configurationData.value
        }
    })
}

export const DeleteConfiguration = (productName, configurationName, credentials) => {
    return axios({
        method: 'delete',
        url: `${env.apiBaseUrl}/api/configurations/${productName}/${configurationName}`,
        headers: {},
        auth: {
            username: credentials.username,
            password: credentials.password
        }
    })
}
